<template>
<!-- HEADER -->

<header class="main_header">
  <div class="header_logos">
    <a href="http://www.anfr.fr" target="_blank">
      <img src="../assets/img/logo-marianne-anfr.svg" alt="République Française" class="logo logo-marianne">
    </a>
    <router-link to="/">
      <img src="../assets/img/logo-cartoradio.svg" alt="Cartoradio" class="logo logo-cartoradio">
    </router-link>
  </div>
  <div class="languages">
    <div class="languages_block">
      <div @click="setLocale('fr')" class="french flag" />
      <div @click="setLocale('en')" class="english flag" />
    </div>
  </div>
  <div id="moncr-veil" onclick="document.body.classList.remove('moncr-em')" />
  <div class="login">
    <div class="login_block" v-show="!$store.state.user.login">
      <div class="login_form">
        <div class="login_btn">
          <button @click="monCartoradio" class="connexion_modal">
                            <span class="normal">{{ $t("message['Se connecter à mon cartoradio']")}}</span>
                            <span class="mobile">{{ $t("message['Connexion']")}}</span>
                        </button>
        </div>
        <div class="header_login_form">
          <p class="login_title">{{ $t("message['Mon Cartoradio - Connexion']")}}</p>
        </div>

        <div id="signup" class="tools_modal">
          <!-- Modal content -->
          <div class="tools_modal_content">
            <button class="tools_modal_close" @click="close('signup')"></button>
            <div class="tools_modal_header">
              {{ $t("message['Inscription']")}}
            </div>
            <div class="signup-dialog-content">
              <div class="tools_modal_text">{{ $t("message['Pour vous inscrire, veuillez renseigner les champs suivants']")}}.</div>
              <table class="inscription_table">
                <tbody>
                  <tr>
                    <td>E-mail</td>
                    <td><input type="text" v-model="signupUsername" class="signupInput" placeholder="E-mail"></td>
                  </tr>
                  <tr>
                    <td>{{ $t("message['Mot de passe']")}}</td>
                    <td><input type="password" v-model="signupPassword" class="signupInput" :placeholder="$t('message[\'Mot de passe\']')"></td>
                  </tr>
                  <tr>
                    <td>{{ $t("message['Mot de passe']")}} (confirmation)</td>
                    <td><input type="password" v-model="signupPasswordconfirmation" class="signupInput" :placeholder="$t('message[\'Mot de passe\']')"></td>
                  </tr>
                  <tr>
                    <td>
                      <div class="checkboxes" :class="{required: isRequired}">
                        <input type="checkbox" v-model="consentement" id="consentement" />
                        <i18n path="message['J accepte les']" tag="label" for="consentement">
                          <a href="#cgu" target="_blank">&nbsp;{{ $t('message[\'CGU\']') }}&nbsp;</a>
                        </i18n>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("message['Recopiez le texte ci-contre']")}}
                      <br>{{ $t("message['dans le champs au-dessous']")}}.
                    </td>
                    <td>

                      <div id="signup-captcha"><img :src="'/api/v1/captcha?dummy='+ captchaImg">
                        <br>
                        <a class="cr-captcha" href="#" @click="changeImg">{{ $t("message['Je n arrive pas à lire. Essayer un autre mot']")}}.</a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td><input type="captcha" id="signup-captchaconfirmation" v-model="captchaConfirmation" class="signupInput" :placeholder="$t('message[\'Recopiez ici\']')"></td>
                  </tr>
                  <tr>
                    <b class="errorSignup" v-if="emptySignup">{{ $t("message['L email, le mot de passe et sa confirmation sont obligatoires']")}}.</b>
                    <b class="errorSignup" v-if="invalidSignupUsername">{{ $t("message['Le format de l email n est pas valide. Utilisez une adresse au format: utilisateur@email.com']")}}.</b>
                    <b class="errorSignup" v-if="differentPassword">{{ $t("message['Le mot de passe et sa confirmation doivent être identiques']")}}.</b>
                    <b class="errorSignup" v-if="invalidInscription">{{errorMsgInscription}}</b>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tools_modal_footer">
              <div class="modal-dialog-buttons">
                <button class="fermer" @click="close('signup')">{{ $t("message['Fermer']") }}</button>
                <button class="enregistrer" @click="signup">{{ $t("message['S inscrire']") }}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="form">
          <div class="form_group">
            <label for="user_id">E-mail</label>
            <input v-model="login" type="text" name="user_id" id="user_id" :placeholder="$t('message[\'Identifiant E-mail\']')" />
            <b class="error_subtitle" v-if="emptyLogin">{{ $t("message['L adresse courriel est obligatoire']")}}.</b>
            <b class="empty" v-if="!emptyLogin & invalidMail">{{ $t("message['Veuillez saisir une adresse courriel valide']")}}.</b>
            <b class="empty" v-if="!invalidMail & !emptyLogin & emptyLoginPassword">{{ $t("message['L adresse courriel et le mot de passe sont obligatoires']")}}.</b>
          </div>
          <div class="form_group">
            <label for="user_password">{{ $t("message['Mot de passe']")}} :</label>
            <input v-model="password" type="password" name="user_password" id="user_password" :placeholder="$t('message[\'Mot de passe\']')" />
            <a class="forgot_password" href="#" @click="forgotPassword">{{ $t("message['Mot de passe oublié']")}} ?</a>
          </div>
          <div class="form_group">
            <button @click="signin" class="inscription_modal sign_in">OK</button>
          </div>
          <div class="form_group">
            <button id="sinscrire-btn" @click="open('signup')" class="inscription_modal sign_in">{{ $t("message['S inscrire']")}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="login_block" v-show="$store.state.user.login">
      <div class="logged">
        <span>{{ $t("message['Bienvenue']")}} {{$store.state.user.login}}</span>
        <div class="form_group">
          <div class="form_group">
            <button id="signout-btn" @click="signout" class="inscription_modal sign_in">{{ $t("message['Se déconnecter']")}}</button>
          </div>
        </div>

        <div class="change_map" :style="{ display: $store.state.maps.length!=0 ? 'block' : 'none' }">
          <form v-on:submit.prevent>
            <!--label>Changer la carte :</label-->
            <label>&nbsp;</label>
            <select name="mymaps" @change="changeMap" v-model="selectedMap">
                                <option  disabled value="null" selected>{{ $t("message['Changer la carte']")}}...</option>
                                <option v-for="(map, index) in $store.state.maps" :key="index" :value="map.code">{{map.nom}}</option>
                            </select>
          </form>
          <button class="delete_maps" id="btn_delete_maps" @click="open('delete_maps')">{{ $t("message['Supprimer des cartes']")}}</button>
          <div id="delete_maps" class="tools_modal">
            <!-- Modal content -->
            <div class="tools_modal_content">
              <button class="tools_modal_close" @click="close('delete_maps')"></button>
              <div class="tools_modal_header">
                {{ $t("message['Supprimer des cartes']")}}
              </div>
              <div class="cr_dialogresult">
                <div v-if="$store.state.maps.length!=0" class="tools_modal_text">{{ $t("message['Cliquez sur Supprimer pour supprimer une carte']")}}.</div>
                <div v-else class="tools_modal_text">{{ $t("message['Aucune carte à supprimer']")}}.</div>
                <div v-for="(map, index) in $store.state.maps" :key="index">
                  <div class="cr_mapline">
                    <div class="cr_separator" role="separator"></div>
                    {{map.nom}}
                    <div class="cr_mapbutton" @click="deleteMap(map.code)">{{ $t("message['Supprimer']")}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</header>
</template>

<script>
import '../assets/css/header.css'

// https://github.com/marcuswestin/store.js/
import storeJs from 'store'
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'CrHeader',
  data() {
    return {
      login: '',
      password: '',
      emptyLogin: false,
      emptyLoginPassword: false,
      invalidMail: false,
      selectedMap: null,
      deletedMapLbl: null,
      user: this.$store.state.user ? this.$store.state.user : {},
      captchaImg: this.captchaImg ? this.captchaImg : Math.round(Math.random() * 1000),
      signupUsername: '',
      signupPassword: '',
      signupPasswordconfirmation: '',
      captchaConfirmation: '',
      invalidSignupUsername: false,
      emptySignup: false,
      invalidInscription: false,
      errorMsgInscription: 'erreur',
      differentPassword: false,
      consentement: false,
      isRequired: false
    }
  },
  mounted() {},
  methods: {
    monCartoradio: function() {
      document.body.classList.add('moncr-em')
    },
    changeMap: function() {
      document.body.classList.remove('moncr-em')
      this.$router.push('/cartographie/mymap/' + this.selectedMap + '/' + Math.round(Math.random() * 1000))
      this.selectedMap = null
    },
    setLocale: function(newLocale) {
      this.$root.$i18n.locale = newLocale
      storeJs.set('cr:locale', newLocale)
    },
    changeImg: function() {
      this.captchaImg = Math.round(Math.random() * 1000)
    },
    signin: function() {
      if (this.login !== '' && this.password !== '') {
        this.emptyLogin = false
        this.emptyLoginPassword = false
        var validEmail = this.validEmail(this.login)
        if (validEmail) {
          this.invalidMail = false
          const options = {
            url: '/api/v1/utilisateurs/signin',
            method: 'POST',
            headers: {
              'login': this.login,
              'pwd': this.password
            }
          }
          var self = this
          axios(options)
            .then((response) => {
              if (response.status === 200 && response.data) {
                document.body.classList.remove('moncr-em')
                this.password = ''
                this.$store.state.user.login = response.data.login
                this.$store.state.user.id = response.data.id
                axios.get('/api/v1/cartes', {
                  params: {
                    idUser: response.data.id
                  }
                })
                  .then((maps) => {
                    this.$store.state.maps = maps.data.data
                    this.$notify({
                      group: 'general-notification',
                      type: 'success',
                      text: this.$t("message['Vous êtes connecté en tant que']") + ' ' + response.data.login
                    })
                  })
                  .catch(function(error) {
                    console.error('mymap', error)
                  })
                // On passe sur la carte si on ne l'est pas déjà
                if (!document.body.classList.contains('map')) {
                  this.$router.push('/cartographie/all')
                }
              }
            })
            .catch(function(error) {
              self.$notify({
                group: 'general-notification',
                type: 'error',
                text: self.$t("message['".concat(error.response.data).concat("']")),
                duration: 10000
              })
              console.error('signin', error)
            })
        } else {
          this.invalidMail = true
        }
      } else {
        this.emptyLoginPassword = true
        this.invalidMail = false
        this.emptyLogin = false
      }
    },
    signout: function() {
      document.body.classList.remove('moncr-em')
      axios.post('/api/v1/utilisateurs/signout')
        .then((response) => {
          // this.$store.state.user = {}
          this.$store.state.user.login = ''
          this.$store.state.maps = []
          this.$router.push('/')
        })
        .catch(function(error) {
          console.error('signout', error)
        })
    },
    signup: function() {
      if (this.signupUsername !== '' && this.signupPassword !== '' && this.signupPasswordconfirmation !== '') {
        this.emptySignup = false
        this.invalidInscription = false
        if (!this.consentement) {
          this.isRequired = true
          return
        } else {
          this.isRequired = false
        }
        var validEmail = this.validEmail(this.signupUsername)
        if (validEmail) {
          this.invalidSignupUsername = false
          if (this.signupPassword === this.signupPasswordconfirmation) {
            this.differentPassword = false
            const options = {
              url: '/api/v1/utilisateurs/signup',
              method: 'POST',
              headers: {
                'login': this.signupUsername,
                'pwd': this.signupPassword,
                'captcha': this.captchaConfirmation
              }
            }
            var self = this
            axios(options)
              .then((response) => {
                if (response.data) {
                  this.$store.state.user.login = response.data.login
                  this.close('signup')
                  this.$notify({
                    group: 'general-notification',
                    type: 'success',
                    text: this.$t("message['Vous êtes connecté en tant que']") + ' : ' + response.data.login
                  })
                  this.signupUsername = ''
                  this.signupPassword = ''
                  this.signupPasswordconfirmation = ''
                  this.captchaConfirmation = ''
                  this.consentement = false
                  this.captchaImg = Math.round(Math.random() * 1000)
                }
              })
              .catch(function(error) {
                self.invalidInscription = true
                self.captchaImg = Math.round(Math.random() * 1000)
                var msg = error.response.data.replace(/'/g, ' ')
                self.errorMsgInscription = self.$t("message['" + msg + "']")
                self.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: self.$t("message['Une erreur est survenue lors de la création du compte']")
                })
                console.error('signup', error)
              })
          } else {
            this.differentPassword = true
          }
        } else {
          this.invalidSignupUsername = true
        }
      } else {
        this.emptySignup = true
        this.invalidSignupUsername = false
        this.differentPassword = false
        this.invalidInscription = false
      }
    },

    forgotPassword: function() {
      if (this.login !== '') {
        this.emptyLogin = false
        var validEmail = this.validEmail(this.login)
        if (validEmail) {
          const options = {
            url: '/api/v1/utilisateurs/password',
            method: 'POST',
            params: {login: this.login}
          }
          axios(options)
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  group: 'general-notification',
                  type: 'success',
                  text: this.$t("message['Un courriel va vous être envoyé pour réinitialiser votre mot de passe.']")
                })
                this.emptyLogin = false
              } else {
                this.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: this.$t("message['Il n existe pas de compte associé à cette adresse.']")
                })
              }
            })
            .catch(function(error) {
              console.error('password', error)
            })
        } else {
          this.invalidMail = true
        }
      } else {
        this.emptyLogin = true
      }
    },

    deleteMap: function(mapCode) {
      axios.delete('/api/v1/cartes/' + mapCode)
        .then((response) => {
          if (response.data) {
            var mapToRemove = _.findIndex(this.$store.state.maps, function(o) {
              return o.nom === response.data.data.nom
            })
            this.$store.state.maps.splice(mapToRemove, 1)
            if (this.$store.state.maps.length < 1) {
              this.close('delete_maps')
            }
            this.$notify({
              group: 'general-notification',
              type: 'success',
              text: this.$t("message['La carte ']") + response.data.data.nom + this.$t("message[' a été supprimée avec succès.']")
            })
          } else {
            this.$notify({
              group: 'general-notification',
              type: 'error',
              text: this.$t("message['Une erreur est survenue lors de la suppression de la carte']")
            })
          }
        })
        .catch(function(error) {
          console.error('mymap', error)
        })
    },

    open: function(id) {
      document.body.classList.remove('moncr-em')
      var modal = document.getElementById(id)
      modal.classList.add('active')
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    close: function(id) {
      if (id === 'signup') {
        this.signupUsername = ''
        this.signupPassword = ''
        this.signupPasswordconfirmation = ''
        this.captchaConfirmation = ''
        this.consentement = false
        this.captchaImg = Math.round(Math.random() * 1000)
        this.empty = false
        this.invalidSignupUsername = false
        this.differentPassword = false
        this.invalidInscription = false
      }
      var modal = document.getElementById(id)
      modal.classList.remove('active')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tools_modal_close {
  height: 1.5em;
  width: 1.5em;
  background: none;
  background-image: url(../assets/img/icon-close.svg);
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  position: absolute;
  right: 15px;
  top: 10px;
}

.tools_modal_close:hover,

.tools_modal_close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.tools_modal_text {
  margin-left: 30px;
  color: #afafaf;
  font-style: italic;
}

.tools_modal_content {
  background-color: #fefefe;
  margin: 15% auto;
  background: #fff;
  border: 3px solid #007abc;
  width: fit-content;
  position: relative;
}

.cr_separator {
  border-top: 1px solid #ccc;
  margin: 4px 0;
  padding: 0;
}

.cr_dialogresult {
  padding: 2em;
}

.cr_mapline {
  margin: 0 10px;
}

.cr_mapbutton {
  float: right;
  color: #64c0ff;
  cursor: pointer;
}

.empty {
  color: red;
  position: absolute;
  bottom: -17px;
  left: 0;
  font-size: 0.7em;
  width: max-content;
}

.errorSignup {
  color: red;
  position: absolute;
  font-size: 0.7em;
  max-width: auto;
  overflow-wrap: anywhere;
}

.error_subtitle {
  color: red;
  position: absolute;
  bottom: -17px;
  left: 0;
  font-size: 0.7em;
  width: max-content;
}

.signup-dialog-content {
  margin: 0px 20px 70px 20px;
}

.cr-login-error-hidden {
  display: none;
}

.modal-dialog-buttons {
  padding: 5px 5px 5px 5px;
  height: 22px;
}

.modal-dialog-buttons .enregistrer {
  border: medium none;
  height: 22px;
  background-color: #007abc;
  color: #fff;
  position: absolute;
  right: 10px;
}

.modal-dialog-buttons .fermer {
  border: medium none;
  height: 22px;
  background-color: #007abc;
  color: #fff;
  position: absolute;
  left: 10px;
}

div.tools_modal_content {
  background-color: #fefefe;
  margin: 20% auto;
  background: #fff;
  border: 3px solid #007abc;
  width: fit-content;
  position: relative;
}

div.tools_modal_footer {
  background-color: #007abc;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 40px;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.signupInput {
  width: 80%;
  margin-left: 5px;
}

.cr-captcha {
  color: #64c0ff;
  cursor: pointer;
}

.cr-captcha:hover {
  color: #007abc;
}

.required input[type="checkbox"]+label:before {
  border-color: #f79c9c;
  box-shadow: 0 0 10px red;
}

.required input[type="checkbox"]:checked+label:before {
  border: 1px solid #296c9b;
  box-shadow: none;
  background: #296c9b;
}

.inscription_table .checkboxes input[type="checkbox"] {
  display: block;
  left: inherit;
  top: inherit;
  margin: 0 auto;
}

.inscription_table .checkboxes input[type="checkbox"]+label {
  margin: 25px 0px 10px;
}
</style>
